import React from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import styled from "styled-components";
import {useFadeIn} from "../../hooks/useFadeIn";
import {setFrontSchemaStateField} from "../../../features/schemaManageSlice";
import {SchemaI} from "../../../Types";
import {LANG} from "../../CONSTANTS";
import AsideFrontFieldsSection from "./AsideFrontFieldsSection";


type AsideFrontSchemaI = { schema: SchemaI };
export default function AsideHeaderFrontSchemaFunc({schema}: AsideFrontSchemaI) {

    let dispatch = useAppDispatch();
    const sectionView = useAppSelector(state => state.schemaManage.front.sectionView);
    const selectedTable = useAppSelector(state => state.schemaManage.front.selectedTable);
    const table = useAppSelector(state => state.schemaManage.front.tables[selectedTable].data);

    const style = useFadeIn(); // or useFadeIn({ delay: 100, duration: 500 })

    return <Container style={style}>
        <div className="info">
            {/*<div>Назва: <span className={'val'}>{schema.actName}</span></div>*/}
            {/*<div>Таблиця за замовчуванням: <span className={'val'}>{schema.defaultTable}</span></div>*/}
            {/*<div>Backend: <span className={'val'}>{schema.backend}</span></div>*/}
        </div>
        <div className="selected-table">
            {selectedTable} - {table.title[LANG]}
        </div>
        <div className="section-switch">
            <Btn $active={sectionView === "fields"} className={'btn-cmn'}
                 onClick={() => dispatch(setFrontSchemaStateField("sectionView", "fields"))}>Поля</Btn>
            <Btn $active={sectionView === "filters"} className={'btn-cmn'}
                 onClick={() => dispatch(setFrontSchemaStateField("sectionView", "filters"))}>Фільтри</Btn>
            <Btn $active={sectionView === "main"} className={'btn-cmn'}
                 onClick={() => dispatch(setFrontSchemaStateField("sectionView", "main"))}>Основне</Btn>
        </div>
        {sectionView === "fields" && <AsideFrontFieldsSection selectedTable={selectedTable}/>}
    </Container>
}

const Btn = styled.button<{ $active: boolean }>`
    flex-grow: 1;
    width: 100%;
    border-bottom: 2px solid ${props => props.$active ? "var(--secondary-text)" : "transparent"};

`

const Container = styled.div`

    display: flex;
    flex-flow: column;
    gap: .5rem;
    padding-left: 1rem;
    padding-right: 1rem;

    opacity: 0;

    .selected-table {
        display: flex;
        justify-content: center;
        text-align: center;
        background: var(--secondary-text);
        color: var(--table-action-color);
        padding: .4rem;
        border-radius: .2rem;
        font-weight: bold;
        font-size: 1.1rem;
    }

    & .info {
        display: flex;
        flex-flow: column;
        gap: .5rem;

        .val {
            color: var(--table-action-color);
            font-weight: bold;
        }
    }

    & .section-switch {
        display: flex;
        gap: .5rem;

    }
`
